import { setRoadAccidentsMapFilterString, setRoadAccidentsMapTableFilterString } from "../../../../../stateManagement/reducers/objectTypes/RoadAccidentsSlice";
import { store } from "../../../../../stateManagement/store";
import { roadAccidentCoverStateOptions, roadAccidentLightConditionOptions, roadAccidentTypeOptions, roadAccidentWeatherConditionOptions } from "./RoadAccidentsOverlay";

export function configureRoadAccidentsMapFilterString(roadAccidentsMapFilters: any) {
    let mapFilterArray = []
    // roadAccidentDateFilter
    if (roadAccidentsMapFilters?.date) {
        let roadAccidentDateFilter = (`(Date>=${roadAccidentsMapFilters.date[0]} and Date<=${roadAccidentsMapFilters.date[1]})`)
        mapFilterArray.push(roadAccidentDateFilter)
    }
    // roadAccidentTypeFilter
    if (!roadAccidentsMapFilters?.roadAccidentType?.ignoreRoadAccidentType) {
        let roadAccidentTypeFilter = '';
        let roadAccidentTypeFiltersArray
        let roadAccidentTypeFiltersTempArrayActive = Object.entries(roadAccidentsMapFilters?.roadAccidentType).filter(([key, value]) => (value === true && key !== 'noRoadAccidentType')).map(([key, value]) => key)
        if (roadAccidentTypeFiltersTempArrayActive.length === 0) {
            if (!roadAccidentsMapFilters?.roadAccidentType?.noRoadAccidentType) {
                roadAccidentTypeFilter += `(RelativeAccidentTypeId IS NULL and RelativeAccidentTypeId IS NOT NULL)`
            } else {
                roadAccidentTypeFilter += `(RelativeAccidentTypeId IS NULL)`
            }
        } else {
            roadAccidentTypeFiltersArray = roadAccidentTypeFiltersTempArrayActive.map(key => key === 'noRoadAccidentType' ? null : roadAccidentTypeOptions[key].typeId).filter(item => item != null).flat()
            roadAccidentTypeFilter += `(RelativeAccidentTypeId in (${roadAccidentTypeFiltersArray?.join(',')})`
            roadAccidentTypeFiltersArray.map((roadAccidentTypeId: any, index) => {
                if (roadAccidentTypeId === roadAccidentTypeOptions?.others?.typeId) {
                    let basicRoadAccidentTypeFilterValues = Object.values(roadAccidentTypeOptions).map((item: any) => item?.typeId != 999999 ? item.typeId : null).flat().filter((item: any) => item != null)
                    let othersRoadAccidentTypeString = '('
                    basicRoadAccidentTypeFilterValues.map((roadAccidentTypeId: any, indexIn) => {
                        othersRoadAccidentTypeString += `AccidentTypeId ne ${roadAccidentTypeId}`
                        if (indexIn < basicRoadAccidentTypeFilterValues?.length - 1) {
                            othersRoadAccidentTypeString += ' and '
                        }
                    })
                    othersRoadAccidentTypeString += ')'
                }
            })
            if (roadAccidentsMapFilters?.roadAccidentType?.noRoadAccidentType) {
                roadAccidentTypeFilter += ` or RelativeAccidentTypeId IS NULL)`
            } else {
                roadAccidentTypeFilter += ')'
            }
        }
        mapFilterArray.push(roadAccidentTypeFilter)
    }

    // deathTollFilter
    if (roadAccidentsMapFilters?.deathToll !== "ignoreDeathToll") {
        let roadAccidentDeathTollFilter
        let deathToll = roadAccidentsMapFilters?.deathToll
        if (deathToll === "noVictims") {
            roadAccidentDeathTollFilter = "(DeathRoll=0 or DeathRoll IS NULL)"
                                        + " and (DeathRollChildren=0 or DeathRollChildren IS NULL)"
                                        + " and (DeathRollWithin30days=0 or DeathRollWithin30days IS NULL)" 
                                        + " and (WoundedCount=0 or WoundedCount IS NULL)"
                                        + " and (WoundedCountChildren=0 or WoundedCountChildren IS NULL)"
        }
        if (deathToll === "withVictims") {
            roadAccidentDeathTollFilter = "DeathRoll>0 or DeathRollChildren>0 or DeathRollWithin30days>0 or WoundedCount>0 or WoundedCountChildren>0"
        }
        if (deathToll === "withFatalities") {
            roadAccidentDeathTollFilter = "DeathRoll>0 or DeathRollChildren>0 or DeathRollWithin30days>0"
        }
        mapFilterArray.push(`(${roadAccidentDeathTollFilter})`)
    }
    // lightConditionFilter
    if (!roadAccidentsMapFilters?.lightCondition?.ignoreLightCondition) {
        let lightConditionFilter = '';
        let lightConditionFiltersArray
        let lightConditionFiltersTempArrayActive = Object.entries(roadAccidentsMapFilters?.lightCondition).filter(([key, value]) => (value === true && key !== 'noLightCondition')).map(([key, value]) => key)
        if (lightConditionFiltersTempArrayActive.length === 0) {
            if (!roadAccidentsMapFilters?.lightCondition?.noLightCondition) {
                lightConditionFilter += `(LightConditionId IS NULL and LightConditionId IS NOT NULL)`
            } else {
                lightConditionFilter += `(LightConditionId IS NULL)`
            }
        } else {
            lightConditionFiltersArray = lightConditionFiltersTempArrayActive.map(key => key === 'noLightCondition' ? null : roadAccidentLightConditionOptions[key].lightConditionId).filter(item => item != null).flat()
            lightConditionFilter += `(LightConditionId in (${lightConditionFiltersArray?.join(',')})`
            if (roadAccidentsMapFilters?.lightCondition?.noLightCondition) {
                lightConditionFilter += ` or LightConditionId IS NULL)`
            } else {
                lightConditionFilter += ')'
            }
        }
        mapFilterArray.push(lightConditionFilter)
    }
    // coverStateFilter
    if (!roadAccidentsMapFilters?.coverState?.ignoreCoverState) {
        let coverStateFilter = '';
        let coverStateFiltersArray
        let coverStateFiltersTempArrayActive = Object.entries(roadAccidentsMapFilters?.coverState).filter(([key, value]) => (value === true && key !== 'noCoverState')).map(([key, value]) => key)
        if (coverStateFiltersTempArrayActive.length === 0) {
            if (!roadAccidentsMapFilters?.coverState?.noCoverState) {
                coverStateFilter += `(CoverStateId IS NULL and CoverStateId IS NOT NULL)`
            } else {
                coverStateFilter += `(CoverStateId IS NULL)`
            }
        } else {
            coverStateFiltersArray = coverStateFiltersTempArrayActive.map(key => key === 'noCoverState' ? null : roadAccidentCoverStateOptions[key].coverStateId).filter(item => item != null).flat()
            coverStateFilter += `(CoverStateId in (${coverStateFiltersArray?.join(',')})`
            if (roadAccidentsMapFilters?.coverState?.noCoverState) {
                coverStateFilter += ` or CoverStateId IS NULL)`
            } else {
                coverStateFilter += ')'
            }
        }
        mapFilterArray.push(coverStateFilter)
    }
    // weatherConditionFilter
    if (!roadAccidentsMapFilters?.weatherCondition?.ignoreWeatherCondition) {
        let weatherConditionFilter = '';
        let weatherConditionFiltersArray
        let weatherConditionFiltersTempArrayActive = Object.entries(roadAccidentsMapFilters?.weatherCondition).filter(([key, value]) => (value === true && key !== 'noWeatherCondition')).map(([key, value]) => key)
        if (weatherConditionFiltersTempArrayActive.length === 0) {
            if (!roadAccidentsMapFilters?.weatherCondition?.noWeatherCondition) {
                weatherConditionFilter += `(WeatherConditionCodes IS NULL and WeatherConditionCodes IS NOT NULL)`
            } else {
                weatherConditionFilter += `(WeatherConditionCodes IS NULL)`
            }
        } else {
            weatherConditionFiltersArray = weatherConditionFiltersTempArrayActive.map(key => key === 'noWeatherCondition' ? null : roadAccidentWeatherConditionOptions[key].weatherConditionCode).filter(item => item != null).flat()
            let tempFilterArray: any = []
            weatherConditionFiltersArray.map((item) => {
                tempFilterArray.push(`WeatherConditionCodes LIKE '%${item}%'`)
            })
            weatherConditionFilter += `(${tempFilterArray.join(' or ')}`
            if (roadAccidentsMapFilters?.weatherCondition?.noWeatherCondition) {
                weatherConditionFilter += ` or WeatherConditionCodes IS NULL)`
            } else {
                weatherConditionFilter += ')'
            }
        }
        mapFilterArray.push(weatherConditionFilter)
    }
    if (!roadAccidentsMapFilters?.raions?.ignoreRaions) {
        let raionFilter = ''
        let raionsFiltersArray
        let raionsFiltersArrayActive = Object.entries(roadAccidentsMapFilters?.raions).filter(([key, value]) => (value === true && key !== 'noRaion')).map(([key, value]) => key)
        if (raionsFiltersArrayActive.length === 0) {
            if (!roadAccidentsMapFilters?.raions?.noRaion) {
                raionFilter += `(RaionId IS NULL and RaionId IS NOT NULL)`
            } else {
                raionFilter += `(RaionId IS NULL)`
            }
        } else {
            raionsFiltersArray = Object.entries(roadAccidentsMapFilters?.raions).filter(([key, value]) => (value === true && key !== 'noRaion')).map(([key, value]) => key)
            raionFilter += `(RaionId in (${raionsFiltersArray?.join(',')})`
            if (roadAccidentsMapFilters?.raions?.noRaion) {
                raionFilter += ` or RaionId IS NULL)`
            } else {
                raionFilter += ')'
            }
        }
        mapFilterArray.push(raionFilter)
    }
    let mapFilterString
    if (mapFilterArray?.length > 0) {
        mapFilterString = mapFilterArray.join(' and ')
    }
    store.dispatch(setRoadAccidentsMapFilterString(mapFilterString))
}

export function configureRoadAccidentsTableFilterString(roadAccidentsMapFilters: any) {
    let tableFilterStringArray: any = []
    // roadAccidentDate filter
    if (roadAccidentsMapFilters.date) {
        let roadAccidentDateFilter = (`Date ge ${roadAccidentsMapFilters.date[0]} and Date le ${roadAccidentsMapFilters.date[1]}`)
        tableFilterStringArray.push(`(${roadAccidentDateFilter})`)
    }
    // roadAccidentType filter
    if (!roadAccidentsMapFilters.roadAccidentType.ignoreRoadAccidentType) {
        let roadAccidentTypeFilterArray: any = []
        let allDefiniteRoadAccidentTypeIds = Object.keys(roadAccidentTypeOptions).map((key: any) => roadAccidentTypeOptions[key].typeId != 999999 ? roadAccidentTypeOptions[key].typeId : null).filter(item => item != null)
        Object.entries(roadAccidentsMapFilters.roadAccidentType).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'others') {
                    let othersRoadAccidentTypeString = '('
                    allDefiniteRoadAccidentTypeIds.map((typeId: any) => {
                        othersRoadAccidentTypeString += `AccidentTypeId ne ${typeId} and `
                    })
                    othersRoadAccidentTypeString += `AccidentTypeId ne null)`
                    roadAccidentTypeFilterArray.push(othersRoadAccidentTypeString)
                }
                else if (key == 'noRoadAccidentType') {
                    roadAccidentTypeFilterArray.push('AccidentTypeId eq null')
                } else {
                    roadAccidentTypeFilterArray.push(`AccidentTypeId eq ${roadAccidentTypeOptions[key].typeId}`)
                }
            }
        })
        let roadAccidentTypeFilter = roadAccidentTypeFilterArray?.length > 0 ? roadAccidentTypeFilterArray.join(' or ') : 'AccidentTypeId eq null and AccidentTypeId ne null'
        tableFilterStringArray.push(`(${roadAccidentTypeFilter})`)
    }
    // deathTollFilter
    if (roadAccidentsMapFilters?.deathToll !== "ignoreDeathToll") {
        let roadAccidentDeathTollFilter
        let deathToll = roadAccidentsMapFilters?.deathToll
        if (deathToll === "noVictims") {
            roadAccidentDeathTollFilter = "(DeathRoll eq 0 or DeathRoll eq null)"
                                        + " and (DeathRollChildren eq 0 or DeathRollChildren eq null)"
                                        + " and (DeathRollWithin30days eq 0 or DeathRollWithin30days eq null)"
                                        + " and (WoundedCount eq 0 or WoundedCount eq null)"
                                        + " and (WoundedCountChildren eq 0 or WoundedCountChildren eq null)"
        }
        if (deathToll === "withVictims") {
            roadAccidentDeathTollFilter = "DeathRoll gt 0 or DeathRollChildren gt 0 or DeathRollWithin30days gt 0 or WoundedCount gt 0 or WoundedCountChildren gt 0"
        }
        if (deathToll === "withFatalities") {
            roadAccidentDeathTollFilter = "DeathRoll gt 0 or DeathRollChildren gt 0 or DeathRollWithin30days gt 0"
        }
        tableFilterStringArray.push(`(${roadAccidentDeathTollFilter})`)
    }
    // roadAccidentLightCondition filter
    if (!roadAccidentsMapFilters.lightCondition.ignoreLightCondition) {
        let lightConditionFilterArray: any = []
        Object.entries(roadAccidentsMapFilters.lightCondition).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noLightCondition') {
                    lightConditionFilterArray.push('LightConditionId eq null')
                }
                else {
                    lightConditionFilterArray.push(`LightConditionId eq ${roadAccidentLightConditionOptions[key].lightConditionId}`)
                }
            }
        })
        let lightConditionFilter = lightConditionFilterArray?.length > 0 ? lightConditionFilterArray.join(' or ') : 'LightConditionId eq null and LightConditionId ne null'
        tableFilterStringArray.push(`(${lightConditionFilter})`)
    }
    // roadAccidentCoverState filter
    if (!roadAccidentsMapFilters.coverState.ignoreCoverState) {
        let coverStateFilterArray: any = []
        Object.entries(roadAccidentsMapFilters.coverState).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noCoverState') {
                    coverStateFilterArray.push('CoverStateId eq null')
                }
                else {
                    coverStateFilterArray.push(`CoverStateId eq ${roadAccidentCoverStateOptions[key].coverStateId}`)
                }
            }
        })
        let coverStateFilter = coverStateFilterArray?.length > 0 ? coverStateFilterArray.join(' or ') : 'CoverStateId eq null and CoverStateId ne null'
        tableFilterStringArray.push(`(${coverStateFilter})`)
    }
    // roadAccidentWeatherCondition filter
    if (!roadAccidentsMapFilters.weatherCondition.ignoreWeatherCondition) {
        let weatherConditionFilterArray: any = []
        Object.entries(roadAccidentsMapFilters.weatherCondition).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noWeatherCondition') {
                    weatherConditionFilterArray.push('WeatherConditionCodes eq null')
                }
                else {
                    weatherConditionFilterArray.push(`position('${roadAccidentWeatherConditionOptions[key].weatherConditionCode}', WeatherConditionCodes) gt 0`)
                }
            }
        })
        let weatherConditionFilter = weatherConditionFilterArray?.length > 0 ? weatherConditionFilterArray.join(' or ') : 'WeatherConditionCodes eq null and WeatherConditionCodes ne null'
        tableFilterStringArray.push(`(${weatherConditionFilter})`)
    }
    // roadAccidentRaion filter
    if (!roadAccidentsMapFilters?.raions.ignoreRaions) {
        let raionFilterArray: any = []
        Object.entries(roadAccidentsMapFilters.raions).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noRaion') {
                    raionFilterArray.push('RaionId eq null')
                }
                else {
                    raionFilterArray.push(`RaionId eq ${key}`)
                }
            }
        })
        let raionFilterString = raionFilterArray?.length > 0 ? raionFilterArray.join(' or ') : 'RaionId eq null and RaionId ne null'
        tableFilterStringArray.push(`(${raionFilterString})`)
    }
    let tableFilterString
    if (tableFilterStringArray?.length > 0) {
        tableFilterString = tableFilterStringArray.join(' and ')
    }
    store.dispatch(setRoadAccidentsMapTableFilterString(tableFilterString))
}

export function configureRoadAccidentsInfoRequestBody(roadAccidentsMapFilters: any) {
    let body = {}
    // dates
    let startDate
    let endDate
    if (roadAccidentsMapFilters?.date) {
        startDate = roadAccidentsMapFilters.date[0]
        endDate = roadAccidentsMapFilters.date[1]
    }
    // accidentTypes
    let accidentTypes: any = []
    let allExceptAccidentTypes: any = []
    if (!roadAccidentsMapFilters.roadAccidentType.ignoreRoadAccidentType) {
        Object.entries(roadAccidentsMapFilters.roadAccidentType).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'others') {
                    allExceptAccidentTypes = Object.entries(roadAccidentTypeOptions)?.map(([roadAccidentType, options]: any) => roadAccidentType !== 'others' ? options?.typeId : null).filter((typeId: any) => typeId != null)
                }
                else if (key == 'noRoadAccidentType') {
                    accidentTypes.push(-1)
                }
                else {
                    accidentTypes.push(roadAccidentTypeOptions[key].typeId)
                }
            }
        })
    }
    // deathToll
    let victims
    if (roadAccidentsMapFilters?.deathToll !== "ignoreDeathToll") {
        victims = roadAccidentsMapFilters?.deathToll
    }
    // lightConditions
    let lightConditions: any = []
    if (!roadAccidentsMapFilters.lightCondition.ignoreLightCondition) {
        Object.entries(roadAccidentsMapFilters.lightCondition).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noLightCondition') {
                    lightConditions.push(-1)
                }
                else {
                    lightConditions.push(roadAccidentLightConditionOptions[key].lightConditionId)
                }
            }
        })
    }
    // coverStates
    let coverStates: any = []
    if (!roadAccidentsMapFilters.coverState.ignoreCoverState) {
        Object.entries(roadAccidentsMapFilters.coverState).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noCoverState') {
                    coverStates.push(-1)
                }
                else {
                    coverStates.push(roadAccidentCoverStateOptions[key].coverStateId)
                }
            }
        })
    }
    // raions
    let raions: any = []
    if (!roadAccidentsMapFilters?.raions.ignoreRaions) {
        Object.entries(roadAccidentsMapFilters.raions).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noRaion') {
                    raions.push(-1)
                }
                else {
                    raions.push(parseFloat(key))
                }
            }
        })
    }
    // weatherConditionCodes
    let weatherConditionCodes: any = ""
    if (!roadAccidentsMapFilters.weatherCondition.ignoreWeatherCondition) {
        Object.entries(roadAccidentsMapFilters.weatherCondition).map(([key, checked]: any) => {
            if (checked) {
                if (key == 'noWeatherCondition') {
                    weatherConditionCodes += "0"
                }
                else {
                    weatherConditionCodes += `${roadAccidentWeatherConditionOptions[key].weatherConditionCode}`
                }
            }
        })
    }
    body = {
        ...body,
        accidentTypes,
        lightConditions,
        coverStates,
        raions,
        weatherConditionCodes,
        allExceptAccidentTypes
    }
    if (startDate && endDate) {
        body = { ...body, startDate, endDate }
    }
    if (victims) {
        body = { ...body, victims }
    }
    return body
}